<template>
  <div>
    <WrapperTableLine
      class="customer-wrapper-line"
      :isBtnExpand="isBtnExpand"
      :hightExpand="`${modalHeight}px`"
    >
      <div
        style="width: 100%"
        class="d-flex align-center text-center justify-space-between"
      >
        <TableInfoLine
          class="table-line flex-2"
          :value="custDes"
          :subValue="customer.cust"
        />
        <TableInfoLine class="table-line flex-2" :value="customerAddress" />
        <!-- <TableInfoLine class="table-line" :value="customer.DistLine.linedes" /> -->
        <TableInfoLine class="table-line" :value="lineDays.join(', ')" />
        <TableInfoLine class="table-line" :value="customer.Agent.agentname" />
        <TableInfoLine
          v-if="$route.name === 'customers'"
          class="table-line"
          :value="customer.lastOrderDate ? lastOrderDateFormat : 'אין הזמנות'"
        />
        <TableInfoLine
          v-else-if="$route.name === 'TomorrowOrders'"
          class="table-line"
          :value="
            isCustomerHasOrderForTomorrow
              ? customer.lastOrderSenddateStatus
              : 'לא קיימת הזמנה'
          "
        />
        <TableInfoLine
          class="table-line"
          :value="`₪${formatPrice(customer.balance)} ${
            customer.balance < 0 ? 'זכות' : ''
          }`"
        />
        <v-icon
          @mouseover="changeIcon('hover')"
          @mouseleave="changeIcon('unhover')"
          @click="openInvoiceTableModal"
          color="#801512"
          size="30px"
          :disabled="!customer?.Deliveries?.length > 0"
          :icon="icon"
        />
        <!-- <v-btn variant="plain" active flat class="mr-5">
          <v-icon color="#801512" size="25"> mdi-cellphone-check </v-icon>
          <v-tooltip activator="parent" location="top" text="לקוח באפליקציה"
        /></v-btn> -->
        <div
          v-if="customer.isInApp || isCustomerHasOrderForTomorrow"
          class="d-flex ga-0 align-center"
        >
          <div
            style="width: 100px"
            class="mr-5 ml-5 d-flex ga-2 justify-center"
          >
            <v-chip
              v-if="isCustomerHasOrderForTomorrow"
              @click="$router.push({ path: `/Order/${customer.lastOrderOrd}` })"
              color="#128028"
            >
              <v-tooltip activator="parent" location="bottom"
                >לקוח ביצע הזמנה למחר</v-tooltip
              >
              <v-icon size="22" icon="mdi-clipboard-text-clock-outline "
            /></v-chip>
            <v-chip v-if="customer.isInApp" color="#801512">
              <v-tooltip activator="parent" location="bottom"
                >לקוח באפליקציה</v-tooltip
              >
              <v-icon icon="mdi-cellphone-check"
            /></v-chip>
          </div>
        </div>
        <div v-else style="width: 100px" class="mr-5 ml-5" />
      </div>
      <TableActions
        :isCustCanCreateAnOrder="Boolean(customer.isActive)"
        :lastOrderOrd="
          isCustomerHasOrderForTomorrow ? customer.lastOrderOrd : ''
        "
        :agnetInfo="customer.Agent"
        :customerInfo="customer"
        :cust="customer.cust"
        :id="cust"
        :isBtnExpand="isBtnExpand"
        :backgroundColor="'#36b079'"
        @close-expand="$emit('close-expand')"
        @expand-btn="expandBtn"
        @setHeight="setHeight"
        mode="customer"
      />
    </WrapperTableLine>
    <InvoiceTableModal
      v-if="isInvoiceTableModalOpen"
      :invoicesList="customer?.Deliveries"
      :custDes="customer.custdes + ' ' + customer.cust"
      :custObligo="customer.maxBalance"
      :openModal="isInvoiceTableModalOpen"
      @closeModal="isInvoiceTableModalOpen = false"
    />
  </div>
</template>

<script>
import TableActions from "./TableActions.vue";
import TableInfoLine from "./TableInfoLine.vue";
import WrapperTableLine from "./WrapperTableLine.vue";
import InvoiceTableModal from "../UI/modals/InvoiceTableModal.vue";
import { getNextDays } from "../../dates";
import moment from "moment";
import { formatPrice, truncateText } from "../../utilities";

export default {
  emits: ["set-current-expand-btn", "close-expand"],
  components: {
    WrapperTableLine,
    TableInfoLine,
    TableActions,
    InvoiceTableModal,
  },
  props: {
    customer: {
      type: Object,
    },
    cust: {
      type: Number,
    },
    currentExpandBtn: {
      type: Number,
    },
    tableLineBackground: {
      type: String,
    },
  },
  data() {
    return {
      icon: "mdi mdi-eye-outline",
      isInvoiceTableModalOpen: false,
      modalHeight: 0,
    };
  },
  computed: {
    customerAddress() {
      if (this.customer.city && this.customer.address)
        return truncateText(
          this.customer.city + ", " + this.customer.address,
          25
        );
      return null;
    },
    isCustomerHasOrderForTomorrow() {
      const tomorrow = moment().add(1, "days").format("DD/MM/YYYY");
      const lastOrderDate = moment(this.customer.lastOrderSenddate).format(
        "DD/MM/YYYY"
      );
      return lastOrderDate === tomorrow;
    },
    lastOrderDateFormat() {
      return moment(this.customer.lastOrderDate).format("DD/MM/YYYY");
    },
    custDes() {
      return truncateText(this.customer.custdes, 25);
    },
    lineDays() {
      return getNextDays(this.customer.DistLine);
    },
    isBtnExpand() {
      if (this.currentExpandBtn === this.customer.cust) return true;
      return false;
    },
    alignWrapper() {
      if (this.isBtnExpand) return "start";
      return "center";
    },
  },
  methods: {
    formatPrice(price) {
      return formatPrice(price);
    },
    openInvoiceTableModal() {
      this.isInvoiceTableModalOpen = !this.isInvoiceTableModalOpen;
    },
    changeIcon(mode) {
      switch (mode) {
        case "hover":
          this.icon = "mdi mdi-eye";
          break;
        case "unhover":
          this.icon = "mdi mdi-eye-outline";
          break;
      }
    },
    setHeight(setHeight, itemsLength) {
      if (itemsLength <= 3) this.modalHeight = setHeight + 80;
      else this.modalHeight = setHeight + 30;
    },
    expandBtn() {
      if (!this.isBtnExpand) {
        this.$emit("set-current-expand-btn", this.customer.cust);
      } else {
        this.$emit("set-current-expand-btn", false);
      }
    },
  },
};
</script>
<style scoped lang="scss">
.table-line {
  flex: 1;
  min-width: 120px;
  max-width: 140px;
}

.customer-wrapper-line {
  display: flex;
  justify-content: space-between;
  align-items: v-bind(alignWrapper);
  background: v-bind(tableLineBackground);
}

.v-icon {
  cursor: pointer !important;
}

@media only screen and (max-width: 1024px) {
  .customer-wrapper-line {
    width: fit-content;
  }

  .table-line {
    min-width: 200px;
  }
}
</style>
